import { Button, IconButton, Spinner, Typography } from '@material-tailwind/react'
import { Modal } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { errorToast } from '../../components/toasts/toasts'
import { baseApi } from '../../ConfigApi'
import { blobToBase64, isIterableArray, toStringPrice } from '../../utils/utils'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import CloseDrawerIcon from '../../images/icons/CloseDrawerIcon'
import moment from 'moment'


type PropsModal = {
    open: boolean,
    handleClose: any
}
const ModalViewPaymentTerms = ({
    open,
    handleClose
}: PropsModal) => {

    const { t } = useTranslation()

    const { service_id, contract_id } = useSelector((state: RootState) => state.contract)

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const [data, setData] = useState<any>(null);
    const [isError, setIsError] = useState<boolean>(false);

    const textService = service_id === 1 ? 'text-orange-600' : service_id === 2 ? 'text-blue-700' : 'text-gray-600'

    const fetchData = () => {
        setIsLoading(true)
        setIsError(false)

        axios.post(`${baseApi}/api/ca/methods-tariffs`, { contract_id: contract_id })
            .then((response: any) => {
                if (response.data.res === 'error') {
                    setIsError(true)
                    errorToast({
                        title: t('contract_page.contract'),
                        text: t('tables.error_on_loading')
                    })
                }
                else {
                    setData(response.data)
                }
            })
            .catch(error => {
                console.error(error);
                setIsError(true)
                errorToast({
                    title: t('contract_page.contract'),
                    text: t('tables.error_on_loading')
                })
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    useEffect(() => {
        if (open) fetchData()
        return () => {
            setData(null)
            setIsError(false)
            setIsLoading(true)
        };
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className='flex items-center justify-center'
        >
            <div className={`${(isError || isLoading) ? 'min-w-[300px] bg-white flex justify-center items-center p-[36px]' : 'w-[calc(100%-16px)] tab:w-[50%] bg-gray-100 p-[12px]'}
                      transition-all rounded-[12px]
                `}>
                {
                    isLoading ?
                        <Spinner />
                        :
                        isIterableArray(data) ?
                            <div className='flex flex-col'>
                                <div className='flex justify-between items-center'>
                                    <p className='text-gray-800 p-[16px_10px] mob:p-[16px] pb-[12px] text-[14px] tab:text-[18px] lap:text-[20px]'>
                                        {t(`contract_page.payment_terms`)}
                                    </p>
                                    <IconButton variant="text" color="blue-gray" className='hover:bg-gray-100 active:bg-gray-100 rounded-full' onClick={handleClose}>
                                        <CloseDrawerIcon />
                                    </IconButton>
                                </div>
                                <div className=' overflow-auto'>

                                    <div className='flex items-end justify-between pb-[8px] px-[10px] mob:px-[16px] lap:px-[24px] min-w-[700px]'>
                                        {/* <p className={`w-[15%] font-medium text-[12px] tab:text-[14px] lap:text-[16px] text-gray-500`}>
                                            {t(`contract_page.method_status_title`)}
                                        </p> */}
                                        <p className={`w-[20%] font-medium text-[12px] tab:text-[14px] lap:text-[16px] text-gray-500`}>
                                            {t(`contract_page.method_date_title`)}
                                        </p>
                                        <p className='w-[30%] font-medium text-[12px] tab:text-[14px] lap:text-[16px] text-gray-500'>
                                            {t(`contract_page.method_type_title`)}
                                        </p>
                                        <p className={`w-[30%] font-medium text-[12px] tab:text-[14px] lap:text-[16px] text-gray-500`}>
                                            {t(`contract_page.method_val_title`)}
                                        </p>
                                        <p className='w-[20%] font-medium text-[12px] tab:text-[14px] lap:text-[16px] text-gray-500'>

                                            {t(`contract_page.method_allocation_title`)}
                                        </p>
                                    </div>
                                    <div className='bg-white border-2 border-gray-200 p-[8px_10px] mob:p-[16px] lap:p-[24px] rounded-[16px] grow min-w-[700px] max-h-[75vh]'>
                                        {
                                            data.map((item: any, key: number) => (
                                                <div key={key} className='flex items-center justify-between py-[10px] border-b border-gray-100 last:border-0 '>
                                                    {/* <p className={`w-[15%] font-bold text-[12px] tab:text-[14px] lap:text-[18px]`}>
                                                        {t(`contract_page.method_status_${item.status}`)}
                                                    </p> */}
                                                    <p className={`w-[20%] font-bold text-[12px] tab:text-[14px] lap:text-[16px] ${textService}`}>
                                                        {moment(item.date_from).format('DD.MM.YYYY')}
                                                    </p>
                                                    <p className='w-[30%] font-medium text-[12px] mob:text-[14px] lap:text-[16px] text-gray-800'>
                                                        {
                                                            item.method_type === 3 ?
                                                                <>{t(`contract_page.method_type_${item.method_type}`)}</>
                                                                :
                                                                item?.delta_value ?
                                                                    `${item.delta_type === 2 ? t(`contract_page.delta_type_${item.delta_type}`) : t(`contract_page.delta_type_${item.delta_type}`)}`
                                                                    :
                                                                    ''
                                                        }
                                                    </p>
                                                    <p className={`w-[30%] font-bold text-[14px] lap:text-[16px] ${textService}`}>
                                                        {
                                                            item.method_type === 3 ?
                                                                <>{toStringPrice(item?.fix_price)}{t('contract_page.delta_unit1')}</>
                                                                :
                                                                item?.delta_value ?
                                                                    `   
                                                                    ${item.delta_type === 2 ? '-' : ''} 
                                                                    ${toStringPrice(item?.delta_value)} 
                                                                    ${item?.delta_unit === 1 ?
                                                                        t("contract_page.delta_unit1")
                                                                        :
                                                                        t("contract_page.delta_unit2")
                                                                    }`
                                                                    :
                                                                    ''
                                                        }
                                                    </p>
                                                    <p className='w-[20%] font-medium text-[14px] lap:text-[16px] text-gray-800'>
                                                        {item.allocation ? t('contract_page.allocation_1') : t('contract_page.allocation_0')}
                                                    </p>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            isError ?
                                <div className='flex flex-col items-center gap-[24px]'>
                                    <Typography variant='lead' className='text-[20px] text-center font-bold'>
                                        {t('error_on_load_try_again')}
                                    </Typography>
                                    <Button color='white' onClick={() => fetchData()}>
                                        {t('reload')}
                                    </Button>
                                </div>
                                :
                                ''
                }
            </div>
        </Modal>
    )
}

export default ModalViewPaymentTerms
